// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_39-1";
export var movingGradient = "_39-4";
export var movingGradientBlock = "_39-2";
export var skeleton = "_39-0";
export var skeletonText = "_39-3";